var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackersGameswift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 142",
    style: {
      enableBackground: "new 0 0 200 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000150079334883473930540000013409730862148914363_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127,42.5l2.3-0.6l9.8,3l-1.7-0.2L127,42.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.5716,
    y1: 60.4413,
    x2: 86.2737,
    y2: 82.2313,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEE00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9878,
    style: {
      stopColor: "#FFA902"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.7,52.4L61,70.3L48.2,83.2l16.7-7L100,61.4l-8.9-3.8l-13.3,5.6l7.9-7.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091014858649017162120000011407992352407241133_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.269,
    y1: 89.5934,
    x2: 128.8399,
    y2: 97.2479,
    gradientTransform: "matrix(1 0 0 -1 0 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9878,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091014858649017162120000011407992352407241133_)"
    },
    d: "M116,47.1l2.6,2.7l2.6,2.6l11-4.6 l6.9-2.9L127,42.5L116,47.1z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139,70.3l-17.7-17.8l-2.6-2.6l-2.6-2.7l-4.6-4.6h-9.6h-0.4H86.7l16.5,6.9h5.4l0.4,0.4l13.3,13.4L73,42.5 l10.7-10.8h10.5h5.8h16.3L127,42.5l12.1,2.4l-20-20.1h-9.7H100h-5.8h-3.6h-9.7L74,31.7l-7.9,7.9l-5.3,5.3l6.9,2.9l67.3,28.3 l16.7,7L139,70.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.6,98.1h-4.3v19h4.3V98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.1,113.6c-0.9,0-1.6-0.6-1.6-1.5v-10.3h4.5v-3.6h-4.5v-6.7h-4.3v6.7h-6.4v-1.5c0-1.1,0.5-1.6,1.6-1.6h1.9 v-2.8V92v-0.5h-2.5c-3.2,0-5.3,2.1-5.3,5.2v1.5h-2.9v3.6h2.9v15.4h4.3v-15.4h6.4v10.3c0,3.1,2.4,5.1,5.9,5.1h3v-0.5v-0.8v-2.3 L190.1,113.6L190.1,113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,106.9h8.1c-0.9,3.5-3.7,5.9-7,5.9c-4.8,0-8-3.4-8-8.6c0-5.1,3.2-8.5,8-8.5c2,0,3.9,1,5.3,2.7h5.3 c-2.2-4.2-6.4-7-10.6-7c-7.7,0-12.8,5.1-12.8,12.8c0,7.8,5.1,12.9,12.8,12.9c7.2,0,12-5.1,12-12.9v-1.6H18.6L18.5,106.9 L18.5,106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,99.9c0,0-1.8-1.8-5.4-1.8c-0.1,0-0.3,0-0.4,0c-5.6,0-9.3,3.8-9.3,9.5c0,5.7,3.7,9.5,9.3,9.5 c0.1,0,0.3,0,0.4,0c3.6,0,5.4-1.8,5.4-1.8v1.8h4.3v-9.5v-9.5h-4.3V99.9z M49.1,107.6c0,3.4-2.2,5.7-5.4,5.7 c-3.3,0-5.4-2.3-5.4-5.7c0-3.4,2.2-5.7,5.4-5.7C47,101.9,49.1,104.2,49.1,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,98.1c-0.1,0-0.3,0-0.4,0c-2.8,0.1-4.7,1.3-5.2,1.7c-1.3-1.1-3-1.7-5.2-1.7c-0.1,0-0.3,0-0.4,0 c-1.3,0.1-2.4,0.4-3.3,0.7v-0.7h-4.3v0.4v5.9v1.6v2.5v8.5h4.3v-8.5v-4.1c0-1.6,1.3-2.6,3.3-2.6c2,0,3.2,1,3.3,2.6v1.6v11h4.3 v-12.6c0-1.6,1.3-2.6,3.3-2.6c2,0,3.3,1,3.3,2.6v12.6h4.3v-13.1C82.7,100.5,79.8,98.1,75.5,98.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.5,98.1c-5.8,0-9.7,3.8-9.7,9.5c0,5.7,3.9,9.5,9.7,9.5c4.2,0,7.8-2.5,9.1-6.3h-4.4 c-0.9,1.6-2.7,2.6-4.7,2.6c-2.8,0-4.9-1.9-5.3-4.7h9.1h5.5h0.4v-0.4V108v-0.4C105.2,101.9,101.3,98.1,95.5,98.1z M90.4,105.2 c0.8-2.2,2.7-3.5,5.1-3.5c2.4,0,4.2,1.3,5.1,3.5H90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.6,91.4h-4.3v4.3h4.3V91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.2,110.5l-3.5-12.4h-2.2h-2.2l-3.5,12.4l-4.3-12.4h-4.6l6.5,19h4.5l3.5-12.3l3.5,12.3h4.5l6.5-19h-4.5 L152.2,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.5,102l-0.5-0.1c-2.9-0.6-5.6-1.3-5.6-3c0-1.7,2.2-2.8,5.4-2.8c3.2,0,5.5,1.4,5.8,3.6v0.1h4.9v-0.1 c-0.4-5-4.5-8.2-10.7-8.2c-6.3,0-10.4,3-10.4,7.5c0,5.3,5.6,6.6,10,7.7l0.5,0.1c2.9,0.6,5.6,1.3,5.6,3c0,1.7-2.2,2.8-5.4,2.8 c-3.2,0-5.5-1.4-5.8-3.6v-0.1h-4.9v0.1c0.4,5,4.5,8.2,10.7,8.2c6.3,0,10.4-3,10.4-7.5C129.5,104.4,123.9,103.1,119.5,102z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackersGameswift);
export default __webpack_public_path__ + "static/media/backers-gameswift.6e7b698d99858fa9bd12c9f8fc678082.svg";
export { ForwardRef as ReactComponent };